module.exports = __webpack_public_path__ + "static/media/mp3.e47eada1.svg";